module.exports = __webpack_public_path__ + "img/Royal-am.da1cd5b2.png";